module.exports = __webpack_public_path__ + "static/media/logo.cb718686.png";